// Interfaces with fields from SPs

// API_v2_League_GameDay_GetHeaderData
export interface LeagueGameDayHeaderDetailsData {
  AllowNonMemberSignUp: boolean;
  AttendeeHeaderID: string;
  CanRollBackToThisMatchDate: boolean;
  ClubID: string;
  ClubLogo: string;
  ClubTitle: string;
  Cost_Registration_Member: string;
  Cost_Registration_NonMember: string;
  CountGamesTowardRatings: boolean;
  CountryTitle: string;
  CurrentUser_PoolID: string;
  CurrentUser_PoolID_Sequence1: string;
  CurrentUser_PoolID_Sequence2: string;
  CurrentUser_PoolNumber_Sequence1: number;
  CurrentUser_PoolNumber_Sequence2: number;
  DateCompleteAndLock: string;
  DateCompleteAndLock_UTC: string;
  DateCreated: Date;
  DateLockScores: Date;
  DateStart: Date;
  DidGenerate2ndSequence: boolean;
  FormatID: number;
  FormatTitle: string;
  FromDateTime: Date;
  FromDateTime_UTC: Date;
  IsActiveWaitlist: boolean;
  IsFlexPlaySchedule: boolean;
  IsTest: boolean;
  LeagueID: string;
  LeagueSessionID: string;
  LeagueTypeID: number;
  LeagueTypeTitle: string;
  Location_City: string;
  Location_CountryAbbreviation: string;
  Location_StateAbbreviation: string;
  Location_Title: string;
  LockOptIn: boolean;
  LockScoresByFullName: string;
  Logo: string;
  MatchDateID: string;
  MatchDateTitle: string;
  MaxAttendies: number;
  MaxAttendies_PerGameDay: number;
  MaxWaitingList: number;
  NumberOfFutureMatchDatesStarted: number;
  OptInFromDateTime: string;
  OptInFromDateTime_UTC: string;
  OptInToDateTime: string;
  OptInToDateTime_UTC: string;
  PlayerSignupAndPaymentType: string;
  PlayerTextFee_OptIn: number;
  PlayerTypeID: number;
  PlayerTypeTitle: string;
  PlayersCanEnterTheirOwnScores: boolean;
  PoolID_1stPool_Sequence1: string;
  PoolID_1stPool_Sequence2: string;
  PoolTemplateID: number;
  RankingType: string;
  RankingType_UpDown_NumberOfSequences: number;
  ServeAndEndSelection: string;
  SessionNumber: number;
  StateTitle: string;
  Timezone_IanaID: string;
  Title: string;
  ToDateTime: Date;
  ToDateTime_UTC: string;
  TotalCourts: number;
  TotalGamesAlreadyPlayed: number;
  TotalGamesRemaining: number;
  TotalTeamsYes: number;
  WaitList_OptInToDateTime: Date;
  ShowDateTimeToPublic_PlayingList: boolean;
  ShowDateTimeToPublic_WaitingList: boolean;
  slug: string;
}

// API_v2_League_GetDetails
export interface LeagueDetailsData {
  AdditionalInformation: string;
  AttendeeSessionID_Current?: string;
  BillingEmails: string;
  ClubID: string;
  ClubLogo?: string;
  ClubTitle: string;
  ClubTypeTitle: string;
  ClubSlug: string;
  Description: string;
  FormatTitle: string;
  FormatID: number;
  PlayerTypeID: number;
  IsLocked: boolean;
  IsTest: boolean;
  ImageURL: string;
  LeagueID: string;
  LeagueSessionID_Current?: string;
  LeagueSessionID_Next?: string;
  LeagueSessionID_Previous?: string;
  LeagueTypeDescription: string;
  LeagueTypeTitle: string;
  LeagueTypeID: number;
  Logo: string;
  MatchDateOptInID_Current?: string;
  MatchDateTitle_Current?: string;
  OnlineStoreURL: string;
  PaymentCurrencyFormatTag: string;
  PaymentCurrencyAbbreviation: string;
  PlayerGroupDescription: string;
  PlayerGroupTitle: string;
  PlayerTypeDescription: string;
  PlayerTypeTitle: string;
  PlayersCanEnterTheirOwnScores: boolean;
  PlayersRequireFullAddress: boolean;
  RefundPolicy: string;
  RequirePartnerPhoneOnManualEntry: boolean;
  SessionNumberList: string;
  SessionNumber_Current?: number;
  SessionNumber_Next?: number;
  SessionNumber_Previous?: number;
  Title: string;
  TurnOffNotifications: boolean;
  URL: string;
  UseSeniorAndU50: boolean;
  WaiverClickCount_Director: number;
  WaiverClickCount_Facility: number;
  WaiverExtension_Director: string;
  WaiverExtension_Facility: string;
  WaiverFile_Director: string;
  WaiverFile_Facility: string;
  isFavorite: boolean;
  slug: string;
}

// API_v2_League_GetSessions
export interface LeagueSessionsData {
  AgeFactor: string;
  AgeFrom: number;
  AgeRangeForUI: string;
  AgeTo: number;
  AllowNeedAPartner: boolean;
  AllowNonMemberSignUp: boolean;
  AttendeeSession_MatchDatesPlayed: number;
  BallUsed: string;
  BallURL: string;
  CanPlayersPlayDownInAge: boolean;
  CanPlayersPlayUpRanking: boolean;
  City: string;
  CountryAbbreviation: string;
  CountryTitle: string;
  ClubMemberStatus: number;
  Location_City: string;
  Location_CountryAbbreviation: string;
  Location_StateAbbreviation: string;
  Location_StreetAddress: string;
  Location_Title: string;
  Location_Zip: string;
  StateTitle: string;
  StreetAddress: string;
  ClubID: string;
  CompleteAndLockByFullName?: string;
  Cost_Registration_Member: string;
  Cost_Registration_NonMember: string;
  CountGamesTowardClubRatings: boolean;
  CountGamesTowardRatings: boolean;
  CourtRunType: string;
  CreatedByFullName: string;
  DateAgeLimitDeadline: Date;
  DateCompleteAndLock: string;
  DateCreated: Date;
  DateDeleted?: Date;
  DateDisabled?: Date;
  DateUpdated: string;
  DeletedByFullName: string;
  DidPlayInPreviousSession: number;
  DisabledByFullName: string;
  EstMinutesPerMatch_TeamCount_10: number;
  EstMinutesPerMatch_TeamCount_11: number;
  EstMinutesPerMatch_TeamCount_12: number;
  EstMinutesPerMatch_TeamCount_13: number;
  EstMinutesPerMatch_TeamCount_14: number;
  EstMinutesPerMatch_TeamCount_15: number;
  EstMinutesPerMatch_TeamCount_16: number;
  EstMinutesPerMatch_TeamCount_2: number;
  EstMinutesPerMatch_TeamCount_3: number;
  EstMinutesPerMatch_TeamCount_4: number;
  EstMinutesPerMatch_TeamCount_5: number;
  EstMinutesPerMatch_TeamCount_6: number;
  EstMinutesPerMatch_TeamCount_7: number;
  EstMinutesPerMatch_TeamCount_8: number;
  EstMinutesPerMatch_TeamCount_9: number;
  Group10_MatchDateBonus: string;
  Group1_MatchDateBonus: string;
  Group2_MatchDateBonus: string;
  Group3_MatchDateBonus: string;
  Group4_MatchDateBonus: string;
  Group5_MatchDateBonus: string;
  Group6_MatchDateBonus: string;
  Group7_MatchDateBonus: string;
  Group8_MatchDateBonus: string;
  Group9_MatchDateBonus: string;
  GroupPlayerCountBreakdown_DefaultChoice1: number;
  GroupPlayerCountBreakdown_DefaultChoice2: number;
  HideRatingsOnStandings: boolean;
  IfCanPlayDownInAge_OnlyAllowOneAboveTheToAgeLimit: boolean;
  IfCanPlayUpInRank_OnlyAllowOneLowerThenFromRankLimit: boolean;
  IfNotAgeAfterSessionStartCanContinueToEnd: boolean;
  IfNotRankAfterSessionStartCanContinueToEnd: boolean;
  IsActiveWaitlist: boolean;
  IsFlexPlaySchedule: boolean;
  IsLiveSession: boolean;
  IsLockedSettings: boolean;
  IsReadOnlyMode: boolean;
  IsSanctioned: boolean;
  LeagueID: string;
  LeagueSessionID: string;
  LeagueSessionID_CopiedFrom?: string;
  LeagueTitle: string;
  League_TextPricePerRegistration: string;
  LiveSession_LeagueSessionID: string;
  LiveSession_SessionNumber: number;
  LocationID: string;
  MatchDateFirstDate: Date;
  MatchDateID_Cur: string;
  MatchDateID_Nxt: string;
  MatchDateLastDate: Date;
  MatchDateOptInID_Cur?: string;
  MatchDateOptInID_Nxt?: string;
  MaxAttendies: number;
  MaxMovementFromCurrentWeek: number;
  MaxMovementRule: string;
  MaxWaitingList: number;
  NumberOfRoundRobins: number;
  NumberOfRoundRobins_TeamCount_10: number;
  NumberOfRoundRobins_TeamCount_11: number;
  NumberOfRoundRobins_TeamCount_12: number;
  NumberOfRoundRobins_TeamCount_13: number;
  NumberOfRoundRobins_TeamCount_14: number;
  NumberOfRoundRobins_TeamCount_15: number;
  NumberOfRoundRobins_TeamCount_16: number;
  NumberOfRoundRobins_TeamCount_2: number;
  NumberOfRoundRobins_TeamCount_3: number;
  NumberOfRoundRobins_TeamCount_4: number;
  NumberOfRoundRobins_TeamCount_5: number;
  NumberOfRoundRobins_TeamCount_6: number;
  NumberOfRoundRobins_TeamCount_7: number;
  NumberOfRoundRobins_TeamCount_8: number;
  NumberOfRoundRobins_TeamCount_9: number;
  NumberOfTimeouts_TeamCount_10: number;
  NumberOfTimeouts_TeamCount_11: number;
  NumberOfTimeouts_TeamCount_12: number;
  NumberOfTimeouts_TeamCount_13: number;
  NumberOfTimeouts_TeamCount_14: number;
  NumberOfTimeouts_TeamCount_15: number;
  NumberOfTimeouts_TeamCount_16: number;
  NumberOfTimeouts_TeamCount_2: number;
  NumberOfTimeouts_TeamCount_3: number;
  NumberOfTimeouts_TeamCount_4: number;
  NumberOfTimeouts_TeamCount_5: number;
  NumberOfTimeouts_TeamCount_6: number;
  NumberOfTimeouts_TeamCount_7: number;
  NumberOfTimeouts_TeamCount_8: number;
  NumberOfTimeouts_TeamCount_9: number;
  OnStandings_HideAgainst: boolean;
  OnStandings_HideEarned: boolean;
  OnStandings_HideMaxMovement: boolean;
  OnStandings_HideMissCurrentWeek: boolean;
  OnStandings_HideNumberWeeksMissed: boolean;
  OnStandings_HideNumberWeeksPlayed: boolean;
  OnStandings_HidePenalty: boolean;
  OnStandings_HidePossible: boolean;
  OnStandings_HidePrevWeek: boolean;
  OnStandings_HideRatingOrEarnedToPossiblePercentage: boolean;
  OnStandings_HideRatingOrEarnedToPossiblePercentageMinusPenalty: boolean;
  OnStandings_Hide_Custom_TotalGameLosses: boolean;
  OnStandings_Hide_Custom_TotalGameWins: boolean;
  OnStandings_Hide_Custom_TotalMatchLosses: boolean;
  OnStandings_Hide_Custom_TotalMatchWins: boolean;
  OnStandings_Hide_Custom_TotalPoints_ForPlayingThatDay: boolean;
  OnStandings_Hide_Custom_TotalPoints_ForWinningAGame: boolean;
  OnStandings_Hide_Custom_TotalPoints_ForWinningAMatch: boolean;
  OnStandings_Hide_Custom_TotalPoints_ForWinningAStraightMatch: boolean;
  OnStandings_Hide_Custom_TotalPoints_LostForLosingAMatch: boolean;
  OnStandings_Hide_Custom_TotalPoints_LostForLosingAStraightMatch: boolean;
  OnStandings_Hide_Custom_TotalPoints_LostForLosingGame: boolean;
  OnStandings_Hide_Custom_TotalPoints_SumOfResult: boolean;
  OnStandings_Hide_Custom_TotalStraightMatchLosses: boolean;
  OnStandings_Hide_Custom_TotalStraightMatchWins: boolean;
  OnlineRegistration_Active: boolean;
  PlayerSignupAndPaymentType: string;
  PlayerTextFee_OptIn: number;
  PlayerTypeID: number;
  PrintNextAvailableMatchesAutomatically: boolean;
  RankFactor: string;
  RankFrom: string;
  RankFromHierarchy: string;
  RankIDFrom: number;
  RankIDTo: number;
  RankRangeForUI: string;
  RankTo: string;
  RankToHierarchy: string;
  RankingType: string;
  RankingType_Custom_PointsLostPerLosingGame: number;
  RankingType_Custom_PointsLostPerLosingMatch: number;
  RankingType_Custom_PointsLostPerLosingStraightMatch: number;
  RankingType_Custom_PointsPerPlayingGame: number;
  RankingType_Custom_PointsPerWinningGame: number;
  RankingType_Custom_PointsPerWinningMatch: number;
  RankingType_Custom_PointsPerWinningStraightMatch: number;
  RankingType_UpDown_NumberOfMissWeeksInRowToPenalize: number;
  RankingType_UpDown_NumberOfSequences: number;
  RankingType_UpDown_TotalMoving: number;
  RankingType_UpDown_WeekMiss_SubtractAmount: number;
  Rating_1stChoice: string;
  Rating_2ndChoice?: string;
  Rating_3rdChoice?: string;
  Rating_4thChoice?: string;
  Registration_DateClosed: Date;
  Registration_DateClosed_UTC: Date;
  Registration_DateOpen: Date;
  Registration_DateOpen_UTC: Date;
  Registration_DateOpen_CurrentPlayers: Date;
  ScoreByePoints_TeamCount_3: number;
  ScoreByePoints_TeamCount_5: number;
  ScoreByePoints_TeamCount_6: number;
  ScoreFormatID_TeamCount_10: number;
  ScoreFormatID_TeamCount_11: number;
  ScoreFormatID_TeamCount_12: number;
  ScoreFormatID_TeamCount_13: number;
  ScoreFormatID_TeamCount_14: number;
  ScoreFormatID_TeamCount_15: number;
  ScoreFormatID_TeamCount_16: number;
  ScoreFormatID_TeamCount_2: number;
  ScoreFormatID_TeamCount_3: number;
  ScoreFormatID_TeamCount_4: number;
  ScoreFormatID_TeamCount_5: number;
  ScoreFormatID_TeamCount_6: number;
  ScoreFormatID_TeamCount_7: number;
  ScoreFormatID_TeamCount_8: number;
  ScoreFormatID_TeamCount_9: number;
  ScoreIsDoubleRR_TeamCount_3: boolean;
  Score_TieBreakerID1: number;
  Score_TieBreakerID2: number;
  Score_TieBreakerID3: number;
  Score_TieBreakerID4: number;
  ScrambleSeedingWithinGroupForMatches: boolean;
  ServeAndEndSelection: string;
  SessionNumber: number;
  Session_MatchesPlayed: number;
  ShowToPublicDate: Date;
  StepsCompleted: number;
  Timezone_IanaID: string;
  TeamCountWhereBothAreRegistered: number;
  TeamCountWhereBothAreRegistered_OnHold: number;
  TeamCountWhereOnlyOneIsRegistered: number;
  TeamCountWhereOnlyOneIsRegistered_OnHold: number;
  Team_TotalFemales: number;
  Team_TotalMales: number;
  TeammateMustRegisterWithinTimeLimit_CalculatedSeconds: number;
  TeammateMustRegisterWithinTimeLimit_Days: number;
  TeammateMustRegisterWithinTimeLimit_Hours: number;
  TeammateMustRegisterWithinTimeLimit_Minutes: number;
  TotalMatchDates: number;
  TotalRegistrations: number;
  TotalRegistrations_OnHold: number;
  UpDown_NumberOfTeams_AdditionToNonUpDownRankingType: number;
  UpdatedByFullName: string;
  WeekMiss_NumberOfWeeks: number;
  WeekMiss_SubtractAmount: string;
  WhereAreNewPlayersStarted: string;
  Zip: string;
  SurfaceTypeTitle: string;
  PlayAreaTypeTitle: string;
  NumberOfCourts: number;
  NetTypeTitle: string;
  ParkingInformation: string;
  IsParkingFee: boolean;
}

// API_v2_League_GetGameDays
export interface LeagueGameDaysData {
  AltName: string;
  AttendeeHeaderID?: string;
  AttendeeSessionID?: string;
  CanRollBackToThisMatchDate: boolean;
  City: string;
  ClubID: string;
  ClubTitle: string;
  CountryAbbreviation: string;
  CountryTitle: string;
  CreatedByFullName: string;
  CurrentUser_PoolID?: string;
  CurrentUser_PoolID_Sequence1?: string;
  CurrentUser_PoolID_Sequence2?: string;
  DateCreated: Date;
  DateLockScores?: Date;
  DateStart: Date;
  DateStatsCalculatedForThisMatchDate?: Date;
  DateUpdated: Date;
  DidGenerate2ndSequence: boolean;
  FromDateTime: Date;
  FromDateTime_UTC: Date;
  IsLiveSession: number;
  IsReadOnlyMode: number;
  LeagueID: string;
  LeagueSessionID: string;
  LeagueTitle: string;
  LocationID?: string;
  LockOptIn: boolean;
  LockScoresByFullName: string;
  MatchDateID: string;
  MatchDateNumber: number;
  MatchDateOptInID?: string;
  MaxAttendies_PerGameDay: number;
  NoSpecifiedEndTime: boolean;
  NoSpecifiedStartTime: boolean;
  NumberOfFutureMatchDatesStarted: number;
  OptInFromDateTime: string;
  OptInToDateTime: string;
  OptInFromDateTime_UTC: string;
  OptInToDateTime_UTC: string;
  PlayerTypeID: number;
  PlayerTypeTitle: string;
  PoolID_1stPool_Sequence1: string;
  PoolID_1stPool_Sequence2?: string;
  PoolTemplateDefaultPlayerCountBreakdown: string;
  PoolTemplateID: number;
  PoolTemplateTitle: string;
  RemovedTeamAfterGroupsSplit: boolean;
  SessionNumber: number;
  SessionTeamID?: string;
  SpecialInstructions: string;
  StartByFullName: string;
  StateAbbreviation: string;
  StateTitle: string;
  StreetAddress: string;
  Title: string;
  ToDateTime: Date;
  ToDateTime_UTC: string;
  TotalGamesAlreadyPlayed: number;
  TotalGamesRemaining: number;
  TotalPools: number;
  TotalCourts: number;
  TotalTeams: number;
  TotalTeamsWait: number;
  TotalTeamsYes: number;
  UpdatedByFullName: string;
  Venue: string;
  WaitList_OptInToDateTime: Date;
  Zip: string;
  Timezone_IanaID: string;
}

//API_v2_League_GameDay_GetRSVP
export interface LeagueRSVPData {
  AttendeeSessionID_1: string;
  AttendeeSessionID_2?: string;
  CanPlayInRank_1?: number;
  CanPlayInRank_2?: number;
  CanPlayInAge_1?: number;
  CanPlayInAge_2?: number;
  CurrentSeedNumber: number;
  ClubMemberStatus_1: number;
  ClubMemberStatus_2: number;
  DOB_1: Date;
  DOB_2?: Date;
  DateCreated: string;
  DateCheckIn_User1?: Date;
  DateCheckIn_User2?: Date;
  DateLockScores?: Date;
  DateOptIn: string;
  Email_1: string;
  Email_2: string;
  FirstName_1: string;
  FirstName_2: string;
  Gender_1: string;
  Gender_2?: string;
  LastName_1: string;
  LastName_2: string;
  LeagueSessionID: string;
  LockOptIn: boolean;
  MatchDateID: string;
  MatchDateOptInID: string;
  NameSuffix_1: string;
  NameSuffix_2: string;
  OptInByFullName: string;
  Phone_1: string;
  Phone_2: string;
  Phone_AreaCode_1: string;
  Phone_AreaCode_2: string;
  Phone_CallingCode_1: string;
  Phone_CallingCode_2: string;
  SendInGameTexts_1: boolean;
  SendInGameTexts_2: boolean;
  SessionTeamID: string;
  ShowAgeToPublic_1?: boolean;
  ShowAgeToPublic_2?: boolean;
  StatsSeedOnGameDay: string;
  UserID_1: string;
  UserID_2?: string;
  DUPR_ID_1: string;
  DUPR_ID_2: string;
}

// API_v2_Club_IsMemberOf
export interface ClubMemberData {
  ID: string;
  Logo: string;
  UserToClubID: string;
}

// API_v2_League_GameDay_GetGroups
export interface LeagueGetGroupsData {
  ByeMatchPoints: number;
  CurrentSeedNumber: number;
  DOB_1: Date;
  DOB_2?: Date;
  DateCheckIn_User1?: Date;
  DateCheckIn_User2?: Date;
  DateLockScores?: Date;
  DateOptIn: Date;
  DateStart: Date;
  Email_1: string;
  Email_2?: string;
  EstMinutesPerMatch: number;
  FirstName_1: string;
  FirstName_2: string;
  Gender_1: string;
  Gender_2?: string;
  LastName_1: string;
  LastName_2: string;
  LeagueSessionID: string;
  LockOptIn: boolean;
  LockScoresByFullName: string;
  MatchCount: number;
  MatchDateID: string;
  MatchDateOptInID: string;
  MaxGames: number;
  NameSuffix_1?: string;
  NameSuffix_2?: string;
  NumberOfTeamsInPool: number;
  NumberOfTimeouts: number;
  OptInByFullName: string;
  Phone_1: string;
  Phone_2?: string;
  Phone_AreaCode_1: string;
  Phone_AreaCode_2?: string;
  Phone_CallingCode_1: string;
  Phone_CallingCode_2?: string;
  PoolID: string;
  PoolNumber: number;
  PoolSeedNumber: number;
  ScoreFormatTitle: string;
  ScoreWinBonusPoints: number;
  SequenceNumber: number;
  SessionTeamID: string;
  Shorthand: string;
  ShowAgeToPublic_1?: boolean;
  ShowAgeToPublic_2?: boolean;
  StartByFullName: string;
  StatsSeedOnGameDay: number;
  TeamDifference_EarnedAgainst: number;
  TeamHeadToHeadWins: number;
  TeamHeadToHead_PointDifferenceWithinHeadToHead: number;
  TeamLosses: number;
  TeamNewSeedNumber: number;
  TeamPointsAgainst: number;
  TeamPointsEarned: number;
  TeamPointsPossible: number;
  TeamWins: number;
  TeamPointDifferencePercentage: string;
  TotalGamesAlreadyPlayed: number;
  TotalReminaingGames: number;
  UseHeadToHeadWins: boolean;
  UserID_1: string;
  UserID_2?: string;
  OrderChanged: boolean;
  IsByeOnFirstMatch: boolean;
}

// AppItems_GetRoundRobinSwitchTemplate_TotalCourts
export interface LeagueCourts {
  MaxCourtsNeeded: number;
}

// API_v2_League_GetRRScramblePoolSplits
export interface LeagueRRScramblePoolSplitsData {
  DateFinish: string;
  PoolTemplateID: number;
  MaxCourtsNeeded: number;
  MaxCourtsNeeded_PartnerOrSingles: number;
  NumberOrPlayers: number;
  PoolMaxSize: number;
  PoolMaxSize_DoDoubleRR: boolean;
  PoolMaxSize_TotalCount: number;
  PoolMinSize: number;
  PoolMinSize_DoDoubleRR: boolean;
  PoolMinSize_TotalCount: number;
  Title: string;
  DefaultPlayerCountBreakdown: string;
}

// API_v2_League_GameDay_GetMatchGroups
export interface LeagueGetMatchGroupsData {
  PoolID: string;
  SequenceNumber: number;
  PoolNumber: number;
  NumberOfTeamsInPool: number;
  TotalReminaingGames: number;
}

// API_v2_League_GameDay_GetMatches
export interface LeagueGetMatchesData {
  ByeMatchPoints: number;
  DateFinish: Date;
  DateLocked?: Date;
  DateStart: Date;
  DidCancelMatch: boolean;
  DidPrintNextAvailable: boolean;
  DisplayMatchNumber: number;
  DisplayRoundNumber: number;
  EstMinutesPerMatch: number;
  FirstServer_SessionTeamID: string;
  FormatTitle: string;
  Game1_Max: number;
  Game1_WinBy: number;
  Game2_Max: number;
  Game2_WinBy: number;
  Game3_Max: number;
  Game3_WinBy: number;
  Game4_Max: number;
  Game4_WinBy: number;
  Game5_Max: number;
  Game5_WinBy: number;
  Game_Best: number;
  Game_BestOutOf: number;
  InBracketType: string;
  IsBye: boolean;
  IsInPlayingGroup: number;
  LeagueID: string;
  LeagueSessionID: string;
  LeagueTitle: string;
  LeagueTypeTitle: string;
  MatchDateID: string;
  MatchID: string;
  MaxGames: number;
  NumberOfTeamsInPool: number;
  NumberOfTimeouts: number;
  PT1a_PoolSeedNumber: number;
  PT1b_PoolSeedNumber: number;
  PT2a_PoolSeedNumber: number;
  PT2b_PoolSeedNumber: number;
  PickSide_SessionTeamID: string;
  PlayerGroupTitle: string;
  PlayerTypeTitle: string;
  PoolID: string;
  PoolNumber: number;
  RR_MatchMaxLoserPoints: number;
  RR_MatchMaxWinnerPoints: number;
  RankingType_UpDown_NumberOfSequences: number;
  RoundRobinNumber: number;
  ScoreID: string;
  ScoreTitle: string;
  ScoreWinBonusPoints: number;
  SequenceNumber: number;
  SessionTeamID_Loser_a: string;
  SessionTeamID_Loser_b: string;
  SessionTeamID_Winner_a: string;
  SessionTeamID_Winner_b: string;
  Shorthand: string;
  T1a_AttendeeSessionID: string;
  T1a_DOB: Date;
  T1a_Email: string;
  T1a_FirstName: string;
  T1a_Gender: string;
  T1a_LastName: string;
  T1a_NameSuffix: string;
  T1a_Phone: string;
  T1a_Phone_AreaCode: string;
  T1a_Phone_CallingCode: string;
  T1a_SessionTeamID: string;
  T1a_ShowAgeToPublic: boolean;
  T1a_StatsSeedOnGameDay: number;
  T1a_SubbedPlayer: string;
  T1a_UserID: string;
  T1b_AttendeeSessionID: string;
  T1b_DOB: Date;
  T1b_Email: string;
  T1b_FirstName: string;
  T1b_Gender: string;
  T1b_LastName: string;
  T1b_NameSuffix: string;
  T1b_Phone: string;
  T1b_Phone_AreaCode: string;
  T1b_Phone_CallingCode: string;
  T1b_SessionTeamID: string;
  T1b_ShowAgeToPublic: boolean;
  T1b_StatsSeedOnGameDay: number;
  T1b_SubbedPlayer: string;
  T1b_UserID: string;
  T2a_AttendeeSessionID: string;
  T2a_DOB: Date;
  T2a_Email: string;
  T2a_FirstName: string;
  T2a_Gender: string;
  T2a_LastName: string;
  T2a_NameSuffix: string;
  T2a_Phone: string;
  T2a_Phone_AreaCode: string;
  T2a_Phone_CallingCode: string;
  T2a_SessionTeamID: string;
  T2a_ShowAgeToPublic: boolean;
  T2a_StatsSeedOnGameDay: number;
  T2a_SubbedPlayer: string;
  T2a_UserID: string;
  T2b_AttendeeSessionID: string;
  T2b_DOB: Date;
  T2b_Email: string;
  T2b_FirstName: string;
  T2b_Gender: string;
  T2b_LastName: string;
  T2b_NameSuffix: string;
  T2b_Phone: string;
  T2b_Phone_AreaCode: string;
  T2b_Phone_CallingCode: string;
  T2b_SessionTeamID: string;
  T2b_ShowAgeToPublic: boolean;
  T2b_StatsSeedOnGameDay: number;
  T2b_SubbedPlayer: string;
  T2b_UserID: string;
  Team_1_Game1DidForfeit: boolean;
  Team_1_Game1Score: number;
  Team_1_Game2DidForfeit: boolean;
  Team_1_Game2Score: number;
  Team_1_Game3DidForfeit: boolean;
  Team_1_Game3Score: number;
  Team_1_Game4DidForfeit: boolean;
  Team_1_Game4Score: number;
  Team_1_Game5DidForfeit: boolean;
  Team_1_Game5Score: number;
  Team_1_MatchPointDifference: number;
  Team_2_Game1DidForfeit: boolean;
  Team_2_Game1Score: number;
  Team_2_Game2DidForfeit: boolean;
  Team_2_Game2Score: number;
  Team_2_Game3DidForfeit: boolean;
  Team_2_Game3Score: number;
  Team_2_Game4DidForfeit: boolean;
  Team_2_Game4Score: number;
  Team_2_Game5DidForfeit: boolean;
  Team_2_Game5Score: number;
  Team_2_MatchPointDifference: number;
  UpDown_NumberOfTeams_AdditionToNonUpDownRankingType: number;
}

// API_v2_League_GameDay_VerifyOpt
export interface LeagueVerifyOptData {
  CheckID: string;
  DidPass: boolean;
  Msg: string;
}

// API_v2_League_GameDay_MaxAndActual
export interface LeagueMaxAndActualSpots {
  Max_PerGameDay: number;
  OpedInCount: number;
}

//API_v2_League_GameDay_SaveOptOut ot OptIn
export interface LeagueInOptOutData {
  AttendeeHeaderID: string;
  AttendeeSessionID: string;
  ClubID: string;
  MatchDateOptInID: string;
  ResponseMsg: string;
  TotalClubBalance_PrevAndTemp: string;
}

//API_v2_League_GameDay_GetCompletedMatches
export interface CompletedMatchData {
  DateLocked: Date | null;
  DisplayMatchNumber: number;
  DisplayRoundNumber: number;
  FormatID: number;
  FormatTitle: string;
  Game1_Max: number;
  Game1_WinBy: number;
  Game2_Max: number;
  Game2_WinBy: number;
  Game3_Max: number;
  Game3_WinBy: number;
  Game4_Max: number;
  Game4_WinBy: number;
  Game5_Max: number;
  Game5_WinBy: number;
  Game_Best: number;
  Game_BestOutOf: number;
  InBracketType: string;
  LeagueID: string;
  LeagueSessionID: string;
  LeagueTitle: string;
  LeagueTypeID: number;
  LeagueTypeTitle: string;
  MatchDateID: string;
  MatchID: string;
  MaxGames: number;
  NumberOfTeamsInPool: number;
  PlayerGroupID: number;
  PlayerGroupTitle: string;
  PlayerTypeID: number;
  PlayerTypeTitle: string;
  PoolID: string;
  PoolNumber: number;
  RR_MatchMaxLoserPoints: number;
  RR_MatchMaxWinnerPoints: number;
  RankingType_UpDown_NumberOfSequences: number;
  RoundRobinNumber: number;
  ScoreFormatID: number;
  ScoreID: string;
  ScoreTitle: string;
  SequenceNumber: number;
  SessionTeamID_Loser_a: string;
  SessionTeamID_Loser_b: string;
  SessionTeamID_Winner_a: string;
  SessionTeamID_Winner_b: string;
  Shorthand: string;
  T1a_AttendeeSessionID: string;
  T1a_FirstName: string;
  T1a_LastName: string;
  T1a_NameSuffix: string;
  T1a_SessionTeamID: string;
  T1a_SubbedPlayer: string | null;
  T1a_UserID: string;
  T1b_AttendeeSessionID: string;
  T1b_FirstName: string;
  T1b_LastName: string;
  T1b_NameSuffix: string;
  T1b_SessionTeamID: string;
  T1b_SubbedPlayer: string | null;
  T1b_UserID: string;
  T2a_AttendeeSessionID: string;
  T2a_FirstName: string;
  T2a_LastName: string;
  T2a_NameSuffix: string;
  T2a_SessionTeamID: string;
  T2a_SubbedPlayer: string | null;
  T2a_UserID: string;
  T2b_AttendeeSessionID: string;
  T2b_FirstName: string;
  T2b_LastName: string;
  T2b_NameSuffix: string;
  T2b_SessionTeamID: string;
  T2b_SubbedPlayer: string | null;
  T2b_UserID: string;
  Team_1_Game1DidForfeit: boolean;
  Team_1_Game1Score: number;
  Team_1_Game2DidForfeit: boolean;
  Team_1_Game2Score: number;
  Team_1_Game3DidForfeit: boolean;
  Team_1_Game3Score: number;
  Team_1_Game4DidForfeit: boolean;
  Team_1_Game4Score: number;
  Team_1_Game5DidForfeit: boolean;
  Team_1_Game5Score: number;
  Team_1_MatchPointDifference: number;
  Team_2_Game1DidForfeit: boolean;
  Team_2_Game1Score: number;
  Team_2_Game2DidForfeit: boolean;
  Team_2_Game2Score: number;
  Team_2_Game3DidForfeit: boolean;
  Team_2_Game3Score: number;
  Team_2_Game4DidForfeit: boolean;
  Team_2_Game4Score: number;
  Team_2_Game5DidForfeit: boolean;
  Team_2_Game5Score: number;
  Team_2_MatchPointDifference: number;
  UpDown_NumberOfTeams_AdditionToNonUpDownRankingType: number;
}

// Response from API_v2_League_Search
export interface LeagueSearchData {
  AllowNonMemberSignUp: boolean;
  City: string;
  ClubID: string;
  ClubLogo: string;
  ClubTitle: string;
  Cost_Registration_Member: string;
  Cost_Registration_NonMember: string;
  CountryTitle: string;
  CountryAbbreviation?: string;
  CurMatchDateStartDateTime: Date;
  CurrPage: number;
  FirstMatchDate: Date;
  FormatTitle: string;
  IsFlexPlaySchedule: boolean;
  IsLiveSession: boolean;
  IsLocked: boolean;
  IsReadOnlyMode: boolean;
  IsRegClosed: number;
  LastMatchDate: Date;
  LeagueID: string;
  LeagueLogo?: string;
  LeagueSessionID: string;
  LeagueSessionID_Cur: string;
  LeagueTitle: string;
  LeagueTypeTitle: string;
  LocationID: string;
  MaxAttendies: number;
  OnlineRegistration_Active: boolean;
  PageCount: number;
  PlayerGroupTitle: string;
  PlayerSignupAndPaymentType: string;
  PlayerTypeTitle: string;
  RecordCount: number;
  Registration_DateClosed: Date;
  Registration_DateOpen: Date;
  Registration_DateOpen_CurrentPlayers: Date;
  RowNumber: number;
  SessionNumber: number;
  StateTitle: string;
  StateAbbreviation?: string;
  StreetAddress: string;
  TotalRegistered: number;
  Venue: string;
  Zip: string;
  mng: number;
  TitleSponsorLogo: string;
  TitleSponsorTitle: string;
  slug: string;
  PaymentCurrencyFormatTag: string;
  PaymentCurrencyAbbreviation: string;
  isFavorite: boolean;
}

// Response from /data/leagues_flat_data_search/${slug}
export interface LeagueFlatDataSearch {
  uuid: string;
  slug: string;
  title: string;
  contact_person1_user_uuid: string;
  contact_person2_user_uuid: string;
  contact_form_registration: string;
  contact_form_my_website_account: string;
  contact_form_refunds: string;
  contact_form_other: string;
}

// Response from API_v2_League_Session_GetSchedule
export interface ScheduleResponseData {
  AltName: string;
  AttendeeHeaderID: string;
  AttendeeSessionID: string;
  CanRollBackToThisMatchDate: boolean;
  City: string;
  ClubID: string;
  ClubTitle: string;
  CountryAbbreviation: string;
  CountryTitle: string;
  CreatedByFullName: string;
  CurrentUser_PoolID: string;
  CurrentUser_PoolID_Sequence1: string;
  CurrentUser_PoolID_Sequence2: string;
  DateCreated: string;
  DateLockScores: string;
  DateStart: string;
  DateStatsCalculatedForThisMatchDate: string;
  DateUpdated: string;
  DidGenerate2ndSequence: boolean;
  FromDateTime: string;
  IsLiveSession: number;
  IsReadOnlyMode: number;
  LeagueID: string;
  LeagueSessionID: string;
  LeagueTitle: string;
  LocationID: string;
  LockOptIn: boolean;
  LockScoresByFullName: string;
  MatchDateID: string;
  MatchDateNumber: number;
  MatchDateOptInID: string;
  MaxAttendies_PerGameDay: number;
  NoSpecifiedEndTime: boolean;
  NoSpecifiedStartTime: boolean;
  NumberOfFutureMatchDatesStarted: number;
  OptInFromDateTime: string;
  OptInToDateTime: string;
  PlayerTypeID: number;
  PlayerTypeTitle: string;
  PoolID_1stPool_Sequence1: string;
  PoolID_1stPool_Sequence2: string;
  PoolTemplateDefaultPlayerCountBreakdown: string;
  PoolTemplateID: number;
  PoolTemplateTitle: string;
  RemovedTeamAfterGroupsSplit: boolean;
  SessionNumber: number;
  SessionTeamID: string;
  SpecialInstructions: string;
  StartByFullName: string;
  StateAbbreviation: string;
  StateTitle: string;
  StreetAddress: string;
  Title: string;
  ToDateTime: Date;
  TotalGamesAlreadyPlayed: number;
  TotalGamesRemaining: number;
  TotalPools: number;
  TotalTeams: number;
  TotalTeamsWait: number;
  TotalTeamsYes: number;
  UpdatedByFullName: string;
  Venue: string;
  WaitList_OptInToDateTime: string;
  Zip: string;
}

// Response from API_v2_League_GetMyLeagues
export interface MyLeague {
  AllowNonMemberSignUp_Cur: boolean;
  AllowNonMemberSignUp_Nxt: boolean;
  AltName: string;
  AttendeeHeaderID: string;
  AttendeeSessionID_Cur: string;
  AttendeeSessionID_Nxt: string;
  AttendeeSession_MatchDatesPlayed_Cur: number;
  City: string;
  ClubID: string;
  ClubLogo: string;
  ClubTitle: string;
  Cost_Registration_Member_Cur: string;
  Cost_Registration_Member_Nxt: string;
  Cost_Registration_NonMember_Cur: string;
  Cost_Registration_NonMember_Nxt: string;
  CountryTitle: string;
  CountryAbbreviation?: string;
  CurrPage: number;
  FromDateTime_Cur: string;
  FromDateTime_Nxt: string;
  HasDST: boolean;
  IsFlexPlaySchedule_Cur: boolean;
  IsFlexPlaySchedule_Nxt: boolean;
  IsLiveSession_Cur: boolean;
  IsLiveSession_Nxt: boolean;
  IsLocked: boolean;
  IsLockedSettings_Cur: boolean;
  IsLockedSettings_Nxt: boolean;
  IsReadOnlyMode_Cur: boolean;
  IsReadOnlyMode_Nxt: boolean;
  IsRegClosed?: number; // Field existed in original, but not in your version. Add as needed.
  IsStub: boolean;
  IsTest: boolean;
  LeagueID: string;
  LeagueLogo?: string;
  LeagueSessionID_Cur: string;
  LeagueSessionID_Nxt: string;
  LeagueStatusFilter: string;
  LeagueTitle: string;
  LeagueTypeID: number;
  LockOptIn_Cur: boolean;
  LockOptIn_Nxt: boolean;
  MatchDateCount_Cur: number;
  MatchDateID_Cur: string;
  MatchDateID_Nxt: string;
  MatchDateOptInID_Cur: string;
  MatchDateOptInID_Nxt: string;
  MatchDateTitle_Cur: string;
  MatchDateTitle_Nxt: string;
  NoSpecifiedStartTime_Cur: boolean;
  NoSpecifiedStartTime_Nxt: boolean;
  OnlineRegistration_Active_Cur: boolean;
  OnlineRegistration_Active_Nxt: boolean;
  OptInFromDateTime_Cur: string;
  OptInFromDateTime_Nxt: string;
  OptInToDateTime_Cur: string;
  OptInToDateTime_Nxt: string;
  PaymentCurrencyAbbreviation: string;
  PaymentCurrencyFormatTag: string;
  PlayerSignupAndPaymentType_Cur: string;
  PlayerSignupAndPaymentType_Nxt: string;
  PageCount: number;
  RecordCount?: number; // original field
  Registration_DateClosed_Cur: string;
  Registration_DateClosed_Nxt: string;
  Registration_DateOpen_Cur: string;
  Registration_DateOpen_CurrentPlayers_Cur: string;
  Registration_DateOpen_CurrentPlayers_Nxt: string;
  Registration_DateOpen_Nxt: string;
  SQLName: string;
  SessionNumber?: number;
  SessionNumber_Cur: number;
  SessionNumber_Nxt: number;
  SessionPlayerCount_Cur: number;
  ShowToPublicDate_Cur_UTC: string;
  SessionPlayerCount_Nxt: number;
  ShowToPublicDate_Nxt_UTC: string;
  ShowToPublicDate_Cur: string;
  ShowToPublicDate_Nxt: string;
  StateTitle?: string; // original field exists
  StateAbbreviation?: string;
  StreetAddress?: string; // original field exists
  TitleSponsorLogo?: string;
  TitleSponsorTagline?: string;
  TitleSponsorTitle?: string;
  TitleSponsorURL?: string;
  TotalRegistered?: number; // original field exists in full data
  UTCOffset: number;
  Venue?: string; // original field exists
  Zip?: string; // original field exists
  mng: number;
  slug?: string; // original field exists
  showToPublic: boolean;
  isFavorite: boolean;
}

// Response from API_v2_League_GetMySchedule
export interface MyCompletedScheduleLeague {
  AgeFactor: string;
  AgeFrom: number;
  AgeTo: number;
  AllowNonMemberSignUp: boolean;
  AttendeeHeaderID: string;
  AttendeeSessionID: string;
  AttendeeSessionID_1: string;
  AttendeeSessionID_2: string;
  CanPlayersPlayDownInAge: boolean;
  CanPlayersPlayUpRanking: boolean;
  CanPlayInRank_1?: number;
  CanPlayInRank_2?: number;
  CanPlayInAge_1?: number;
  CanPlayInAge_2?: number;
  City: string;
  ClubID: string;
  ClubTitle: string;
  ClubMemberStatus_1: number;
  ClubMemberStatus_2: number;
  Cost_Registration_Member: string;
  Cost_Registration_NonMember: string;
  CountryAbbreviation: string;
  CountryTitle: string;
  DateAgeLimitDeadline: string;
  DateLockScores: string;
  DateStart: string;
  DateStatsCalculatedForThisMatchDate: string;
  FormatID: number;
  FormatTitle: string;
  FromDateTime: string;
  IfCanPlayDownInAge_OnlyAllowOneAboveTheToAgeLimit: boolean;
  IfCanPlayUpInRank_OnlyAllowOneLowerThenFromRankLimit: boolean;
  IsActiveWaitlist: boolean;
  IsFlexPlaySchedule: boolean;
  IsLiveSession: boolean;
  IsLocked: boolean;
  IsReadOnlyMode: boolean;
  IsStub: boolean;
  IsTest: boolean;
  LeagueID: string;
  LeaguePlayerTypeTitle: string;
  LeagueSessionID: string;
  LeagueTitle: string;
  LeagueTypeID: number;
  LeagueTypeTitle: string;
  LocationID: string;
  LockOptIn: boolean;
  Logo: string;
  MatchDateID: string;
  MatchDateNumber: number;
  MatchDateOptInID: string;
  MatchDateTitle: string;
  MatchDate_PoolID: string;
  MaxAttendies_PerGameDay: number;
  NoSpecifiedEndTime: boolean;
  NoSpecifiedStartTime: boolean;
  OnlineRegistration_Active: boolean;
  OptInFromDateTime: string;
  OptInFromDateTime_UTC: string;
  OptInToDateTime: string;
  OptInToDateTime_UTC: string;
  PlayerGroupID: number;
  PlayerGroupTitle: string;
  PlayerSignupAndPaymentType: string;
  PlayerTypeID: number;
  RankFactor: string;
  RankIDFrom: number;
  RankIDTo: number;
  Registration_DateClosed: string;
  Registration_DateOpen: string;
  Registration_DateOpen_CurrentPlayers: string;
  ScheduledApponent: string;
  SessionNumber: number;
  SessionTeamID: string;
  ShowToPublicDate: string;
  SportID: string;
  StateAbbreviation: string;
  StateTitle: string;
  StreetAddress: string;
  ToDateTime: Date;
  TotalGamesAlreadyPlayed: number;
  TotalTeamsYes: number;
  Timezone_IanaID: string;
  UserID_1: string;
  UserID_2: string;
  Venue: string;
  WaitList_CurrentlyOn: number;
  WaitList_OptInToDateTime: string;
  Zip: string;
  isClubMember?: boolean;
}

// API_v2_League_Reg_GetPartner
export interface LeagueRegGetPartnerData {
  AttendeeSessionID: string;
}

// API_v2_League_Reg_SelectPartner. The Finalize* fields are the game-day half of the SP: they are
// only filled in when a MatchDateID travels with the call, so checkout callers get FinalizeSuccess
// null.
export interface LeagueRegSelectPartnerData {
  FinalizeResponseMsg: string;
  // The SP sends this back as a boolean, so callers normalize it before comparing.
  FinalizeSuccess: boolean | 0 | 1 | null;
  MatchDateOptInID: string | null;
  OuputID: string;
  ReturnCode: number;
  ReturnMessage: string;
  SessionTeamID: string | null;
}

// API_v2_League_Session_SavePlayer. Success 0 is a hard failure - nothing was saved.
export interface LeagueSessionSavePlayerData {
  ResponseMsg: string;
  Success: boolean | number;
}

// Response from API_v2_League_Session_GetPlayers
export interface LeagueSessionGetPlayersData {
  AttendeeHeaderID_1: string;
  AttendeeHeaderID_2?: string;
  AttendeeSessionID_1: string;
  AttendeeSessionID_2?: string;
  CurrentRating: string;
  CurrentRating_AfterPenalties: number;
  CurrentSeedNumber: number;
  CurrentSeedNumber_ForNewPlayerAdded: string;
  DOB_1: Date;
  DOB_2?: Date;
  DateCreated: Date;
  DidMissCurrentMatchDate: boolean;
  DidUseMaxMovementRule: boolean;
  Email_1: string;
  FirstName_1: string;
  FirstName_2: string;
  Gender_1: string;
  Gender_2?: string;
  Group_MatchDateBonus: string;
  IsTestAccount_1: boolean;
  IsTestAccount_2: boolean;
  LastGameDateGroup_Number: number;
  LastGameDateGroup_Place: number;
  LastGameDateGroup_Place_OutOf: number;
  LastName_1: string;
  LastName_2: string;
  LeagueSessionID: string;
  MaxSeed: number;
  MinSeed: number;
  NameSuffix_1: string;
  NameSuffix_2: string;
  Phone_1: string;
  Phone_2: string;
  Phone_AreaCode_1: string;
  Phone_AreaCode_2: string;
  Phone_CallingCode_1: string;
  Phone_CallingCode_2: string;
  PrevRating: number;
  PrevSeedNumber: number;
  SessionStatID: string;
  SessionTeamID: string;
  TeamHeadToHeadWins: number;
  TeamHeadToHead_PointDifferenceWithinHeadToHead: number;
  TotalGameLosses: number;
  TotalGameWins: number;
  TotalLosses: number;
  TotalMatchDate_Missed: number;
  TotalMatchDate_Penalty: string;
  TotalMatchDate_Played: number;
  TotalPoints_Against: number;
  TotalPoints_Bonus: number;
  TotalPoints_Bye: number;
  TotalPoints_Custom_ForPlayingThatDay: number;
  TotalPoints_Custom_ForWinningAGame: number;
  TotalPoints_Custom_ForWinningAMatch: number;
  TotalPoints_Custom_ForWinningAStraightMatch: number;
  TotalPoints_Custom_LostForLosingAMatch: number;
  TotalPoints_Custom_LostForLosingAStraightMatch: number;
  TotalPoints_Custom_LostForLosingGame: number;
  TotalPoints_Custom_SumOfResult: number;
  TotalPoints_Difference_EarnedAgainst: number;
  TotalPoints_Difference_EarnedPossible: number;
  TotalPoints_Difference_EarnedPossible_Percentage: string;
  TotalPoints_Difference_EarnedPossible_Percentage_AfterPenalties: string;
  TotalPoints_Earned: number;
  TotalPoints_Possible: number;
  TotalStraightMatchLosses: number;
  TotalStraightMatchWins: number;
  TotalWins: number;
  UseHeadToHeadWins: boolean;
  UserID_1: string;
  UserID_1_IsClubMember: boolean;
  UserID_2?: string;
  UserID_2_IsClubMember: boolean;
  WouldHaveUsedUseMaxMovementRule: boolean;
  TeamPointDifferencePercentage: string;
  DUPR_ID_1: string;
  DUPR_ID_2: string;
  ProfileImage_1: string;
  ProfileImage_2: string;
}

// Response from API_v2_League_GameDay_SaveOptOut_v2
export interface LeagueOptOutData {
  payload: [LeagueMovedFromWaitToLiveData[], LeagueMovedFromWaitToLiveData[]];
}

// Response from API_v2_League_GameDay_MovedFromWaitToLive
export interface LeagueMovedFromWaitToLiveData {
  DidMoveTeam: boolean;
  Email_1: string;
  Email_2: string;
  FirstName_1: string;
  FirstName_2: string;
  LastName_1: string;
  LastName_2: string;
  LeagueTitle: string;
  MatchDateOptInID: string;
  MatchDateTitle: string;
  NameSuffix_1: string;
  NameSuffix_2: string;
  Phone_1: string;
  Phone_2: string;
  PlayerTextFee_OptIn: number;
  SMS_FromPhoneNumber_1: string | null;
  SMS_FromPhoneNumber_2: string | null;
  SendInGameTexts_1: boolean | null;
  SendInGameTexts_2: boolean | null;
  SessionTitle: string;
  UserID_1: string;
  UserID_2: string | null;
}

// Response from API_v2_League_PlayerGameDayStats
export interface PlayerMatch {
  MatchDateID: string;
  RoundRobinNumber: number;
  DisplayRoundNumber: number;
  DisplayMatchNumber: number;
  Team_1_Game1Score: number;
  Team_1_Game2Score: number;
  Team_1_Game3Score: number;
  Team_1_Game4Score: number;
  Team_1_Game5Score: number;
  Team_2_Game1Score: number;
  Team_2_Game2Score: number;
  Team_2_Game3Score: number;
  Team_2_Game4Score: number;
  Team_2_Game5Score: number;
  SessionTeamID_Winner_a: string;
  SessionTeamID_Winner_b: string | null;
  SessionTeamID_Loser_a: string;
  SessionTeamID_Loser_b: string | null;
  ScoreFormat_Shorthand: string;
  ScoreFormat_MaxGames: number;
  T1_P1_UserID: string;
  T1_P1_FirstName: string;
  T1_P1_LastName: string;
  T1_P1_NameSuffix: string | null;
  T1_P2_UserID: string;
  T1_P2_FirstName: string;
  T1_P2_LastName: string;
  T1_P2_NameSuffix: string | null;
  T2_P1_UserID: string;
  T2_P1_FirstName: string;
  T2_P1_LastName: string;
  T2_P1_NameSuffix: string | null;
  T2_P2_UserID: string;
  T2_P2_FirstName: string;
  T2_P2_LastName: string;
  T2_P2_NameSuffix: string | null;
}

export interface LeaguePlayer {
  AveragePartnerRatingOnGameDay: number;
  Email: string;
  FinalStandingInPool: number;
  FirstName: string;
  FormatID: number;
  HighestOpposingPlayerRating: number;
  HighestOpposingTeamRating: number;
  LastName: string;
  LeaguePlayerType_ID: number;
  LeaguePlayerTypes_Title: string;
  LeagueSessionMatchDate_Date: string; // ISO Date string
  LeagueSessionMatchDate_Title: string;
  LeagueType_ID: number;
  LeagueType_Title: string;
  League_Title: string;
  LowestOpposingPlayerRating: number;
  LowestOpposingTeamRating: number;
  MatchDateID: string;
  Matches: string; // parsed JSON array
  NameSuffix: string | null;
  NumberOfMatchesPlayed: number;
  NumberOfTeamsInPool: number;
  Phone: string;
  Phone_CallingCode: string;
  PlayerRatingOnGameDay: number;
  PointDiff: number;
  PoolNumber: number;
  SendInGameTexts: boolean;
  SessionTeamID: string;
  TeamLosses: number;
  TeamPointsAgainst: number;
  TeamPointsEarned: number;
  TeamRatingOnGameDay: number;
  TeamWins: number;
  TotalPools: number;
  UserID: string;
  WinPercentage: string; // stored as string even though numeric
}
export interface SendSMSAndEmailBody {
  template_id?: string;
  arguments?: string;
  module_for: string;
  module_uuid: string;
  recipient_uuids: string[];
  subject?: string;
  content?: string;
  content_type: string;
}

export enum LeaguesStatus {
  Current = 'current',
  Past = 'past',
  All = 'all',
}

export const statusMap: Record<string, LeaguesStatus> = {
  current: LeaguesStatus.Current,
  closed: LeaguesStatus.Past,
  all: LeaguesStatus.All,
};

export interface PlayerStatsForEmail {
  partnerRating?: number;
  teamRating?: number;
  highestRatingPlayer?: number;
  lowestRatingPlayer?: number;
  highestRatingTeam?: number;
  lowestRatingTeam?: number;
}
